<template>
  <div class="login">
    <div class="login__card glass-card">
      <div class="login__header">
        <div class="login__lang">
          <el-button size="mini" type="primary" class="btn-glass" plain @click="toggleLang">
            {{ $t('common.language') }}: {{ langLabel }}
          </el-button>
        </div>
        <div class="login__title">{{ $t('app.title') }}</div>
      </div>

      <el-form :model="form" :rules="rules" ref="form" label-position="top" @submit.native.prevent="submit">
        <el-form-item :label="$t('auth.username')" prop="username">
          <el-input v-model="form.username" autocomplete="username" />
        </el-form-item>
        <el-form-item :label="$t('auth.password')" prop="password">
          <PasswordInput v-model="form.password" autocomplete="current-password" />
        </el-form-item>

        <el-form-item :label="$t('auth.captcha')" prop="captchaCode">
          <div class="captcha">
            <el-input v-model="form.captchaCode" maxlength="6" />
            <div class="captcha__img" @click="loadCaptcha" :title="$t('auth.captchaRefresh')">
              <img v-if="captchaImage" :src="captchaImage" alt="captcha" />
              <div v-else class="captcha__placeholder">...</div>
            </div>
          </div>
        </el-form-item>

        <el-button type="primary" class="btn-glass" style="width: 100%;" :loading="loading" native-type="submit">
          {{ $t('common.login') }}
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getCaptcha, login } from '../api/auth';
import PasswordInput from '../components/PasswordInput.vue';

export default {
  name: 'Login',
  components: { PasswordInput },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    langLabel() {
      return this.lang === 'zh' ? '中文' : 'EN';
    },
    rules() {
      return {
        username: [{ required: true, message: this.$t('common.required'), trigger: 'blur' }],
        password: [{ required: true, message: this.$t('common.required'), trigger: 'blur' }],
        captchaCode: [{ required: true, message: this.$t('common.required'), trigger: 'blur' }]
      };
    }
  },
  data() {
    return {
      loading: false,
      captchaId: '',
      captchaImage: '',
      form: {
        username: '',
        password: '',
        captchaCode: ''
      }
    };
  },
  created() {
    this.loadCaptcha();
  },
  methods: {
    toggleLang() {
      const next = this.$i18n.locale === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = next;
      try {
        localStorage.setItem('lang', next);
      } catch (e) {}
    },
    async loadCaptcha() {
      const c = await getCaptcha();
      this.captchaId = c.captchaId;
      this.captchaImage = `data:image/png;base64,${c.imageBase64}`;
      this.form.captchaCode = '';
    },
    submit() {
      this.$refs.form.validate(async (ok) => {
        if (!ok) return;
        this.loading = true;
        try {
          await login({
            username: this.form.username,
            password: this.form.password,
            captchaId: this.captchaId,
            captchaCode: this.form.captchaCode
          });
          await this.$store.dispatch('bootstrap');
          if (this.$store.state.mustConfirmAnnouncement) {
            this.$router.replace('/announcements/confirm');
          } else {
            this.$router.replace('/dashboard');
          }
        } catch (e) {
          await this.loadCaptcha();
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login {
  height: 100%;
  display: grid;
  place-items: center;
  padding: 18px;
  box-sizing: border-box;
}
.login__card {
  width: 420px;
  max-width: 95vw;
  padding: 18px;
  position: relative;
}
.login__header {
  margin-bottom: 12px;
  position: relative;
}
.login__lang {
  position: absolute;
  right: 0;
  top: 0;
}
.login__title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 18px;
}
.captcha {
  display: grid;
  grid-template-columns: 1fr 120px;
  gap: 10px;
  align-items: center;
}
.captcha__img {
  height: 40px;
  border-radius: 10px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  overflow: hidden;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  display: grid;
  place-items: center;
}
.captcha__img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.captcha__placeholder {
  color: rgba(71, 85, 105, 0.8);
}
</style>
